<div id="filter-card">
  <dxo-card>
    <div class="header-container">
      <h2 class="card-body-header" data-e2e="BillingCardHeader">Filter invoices</h2>
      <div (click)="clearFilters()" (keydown)="clearFilters()" class="link">Clear filters</div>
    </div>
    <card-body>
      <form [formGroup]="formGroup" (ngSubmit)="submit()">
        <div class="data-containter">
          <div class="text-input">
            <div class="row-input" style="white-space: pre-wrap">
              <dxo-dropdown
                data-e2e="InvoiceDropdown"
                [label]="InvoicePeriodText"
                class="invoicedropdown"
                [dxoDataset]="[{ selector: '.dxo-input, ul', data: { pii: '' } }]"
                (valueChange)="onFilterChange($any($event), 'invoice')"
                [optionsObjects]="invoicePeriodOptions"
                [value]="searchParameter.invoicePeriodString"
              >
              </dxo-dropdown>
              <dxo-dropdown
                data-e2e="BillGroupNumber_dropdown"
                [label]="BillGroupText"
                class="billdropdown"
                [dxoDataset]="[{ selector: '.dxo-input, ul', data: { pii: '' } }]"
                (valueChange)="onFilterChange($any($event), 'group')"
                [optionsObjects]="billGroupNumberOptions"
                [value]="searchParameter.billGroupNumber"
              >
              </dxo-dropdown>
            </div>
          </div>
        </div>
      </form>
    </card-body>
  </dxo-card>
</div>

<div id="invoice-card">
  <dxo-card>
    <div class="header-container">
      <h2 class="card-body-header" data-e2e="InvoicesCardHeader">Invoices</h2>
      <div class="pay-invoice-button">
        <dxo-button
          [primary]="true"
          text="Pay invoice(s)"
          data-category="list"
          data-action="Close Modal"
          (handleClick)="goPayment()"
          [disabled]="!selectedItems.length"
        >
        </dxo-button>
      </div>
    </div>
    <div class="loader-container">
      <dxo-circular-loader *ngIf="isLoading" [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
    </div>
    <card-body *ngIf="billings$ | async as billings">
      <dxo-data-table
        [headers]="tableHeaders"
        [items]="billings.listBilling"
        [showCardViewWhenMobile]="true"
        [dxoDataset]="[{ selector: 'dxo-table-cell > span', data: { pii: '' } }]"
      >
        <ng-template dxoHeaderKey="runDate">
          <span class="sort-header" tabindex="0">
            <dxo-checkbox
              class="selectItem"
              data-name="select item"
              [(value)]="allSelected"
              (valueChange)="selectAll($event)"
            ></dxo-checkbox>
            {{ RunDateText }}
            <dxo-icon
              (click)="onClickTableHeader('RunDate')"
              (keypress)="onClickTableHeader('RunDate')"
              [class.ascending]="
                searchParameter.sortDirection === SortDirection.Ascending && searchParameter.sortField === 'RunDate'
              "
              [color]="searchParameter.sortField === 'RunDate' | getSortIconColor"
              [fontSize]="20"
              [right]="true"
            >
              {{ SortKey }}
            </dxo-icon>
          </span>
        </ng-template>

        <ng-template dxoHeaderKey="invoice">
          <span
            tabindex="0"
            class="sort-header"
            (click)="onClickTableHeader('Invoice')"
            (keypress)="onClickTableHeader('Invoice')"
          >
            {{ InvoicePeriodAndNumberText }}
            <dxo-icon
              [class.ascending]="
                searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'Invoice'
              "
              [color]="searchParameter.sortField === 'Invoice' | getSortIconColor"
              [fontSize]="20"
              [right]="true"
            >
              {{ SortKey }}
            </dxo-icon>
          </span>
        </ng-template>

        <ng-template dxoHeaderKey="billGroup">
          <span
            tabindex="0"
            class="sort-header"
            (click)="onClickTableHeader('BillGroupName')"
            (keypress)="onClickTableHeader('BillGroupName')"
          >
            {{ BillGroupText }}
            <dxo-icon
              [class.ascending]="
                searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'BillGroupName'
              "
              [color]="searchParameter.sortField === 'BillGroupName' | getSortIconColor"
              [fontSize]="20"
              [right]="true"
            >
              {{ SortKey }}
            </dxo-icon>
          </span>
        </ng-template>

        <ng-template dxoHeaderKey="actions">
          {{ ActionsText }}
        </ng-template>

        <ng-template dxoKey="runDate" let-item>
          <span class="row-cell">
            <dxo-checkbox
              class="selectItem"
              data-name="select item"
              [value]="allSelected ? allSelected : item.selected"
              (valueChange)="selectItem(item, $event)"
            ></dxo-checkbox>
            {{ item.runDateString }}
          </span>
        </ng-template>

        <ng-template dxoKey="invoice" let-item>
          <span class="list-cell">{{ item.invoicePeriodString }}</span>
          <span>{{ item.invoiceNumber }}</span>
        </ng-template>

        <ng-template dxoKey="billGroup" let-item>
          <span class="list-cell">{{ item.billGroupName }}</span>
          <span>{{ item.billGroupNumber }}</span>
        </ng-template>

        <ng-template dxoKey="status" let-item>
          <span class="row-cell">
            <span class="status-indicator" [style.background-color]="item.indicator"></span>
            {{ item.status }}
          </span>
        </ng-template>

        <ng-template dxoKey="actions" let-item>
          <span *ngIf="item.actions !== 'Not available'" class="row-cell">
            <dxo-button [textButton]="true" [text]="item.actions" (handleClick)="goPremium(item)"> </dxo-button>
          </span>
          <span *ngIf="item.actions === 'Not available'" class="row-cell">
            {{ item.actions }}
          </span>
        </ng-template>

        <ng-template dxoKey="downloads" let-item>
          <span class="row-cell">
            <div>
              <div class="url-item" *ngIf="item.pdfUrl">
                <a target="blank" [href]="item.pdfUrl">PDF</a>
              </div>
            </div>
            <div>
              <div class="url-item" *ngIf="item.xlsxUrl">
                <a target="blank" [href]="item.xlsxUrl">XLSX</a>
              </div>
            </div>
          </span>
        </ng-template>
      </dxo-data-table>

      <div class="paginator">
        <dxo-server-pagination
          [itemCount]="billings.totalResults"
          [currentPage]="searchParameter.page"
          [pageSize]="searchParameter.pageSize"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
        ></dxo-server-pagination>
      </div>
    </card-body>
  </dxo-card>
</div>
